import { createSlice } from "@reduxjs/toolkit";
import { appRestart } from "src/duck/actions";

const initialState = {
  pairingCode: {
    value: null,
    fetching: false,
    error: false
  }
};

const pairingManuallySlice = createSlice({
  name: "pairingManually",
  initialState,
  reducers: {
    fetchPairingCodeRequest(state) {
      state.pairingCode = {
        value: null,
        fetching: true,
        error: false
      };
    },
    fetchPairingCodeFailure(state) {
      state.pairingCode.error = true;
      state.pairingCode.fetching = false;
    },
    fetchPairingCodeSuccess(state, { payload }) {
      state.pairingCode.value = payload;
      state.pairingCode.fetching = false;
    },
    resetPairingCode(state) {
      state.pairingCode = initialState.pairingCode;
    }
  },
  extraReducers(builder) {
    builder.addCase(appRestart, () => {
      return initialState;
    });
  }
});

export { pairingManuallySlice };
export default pairingManuallySlice.reducer;
